module.exports = __webpack_public_path__ + "img/1579810784.42eff6c8.jpg";